import React from "react";
import {
  Popper,
  Paper,
  ClickAwayListener,
  styled,
  Box,
  TextField,
} from "@mui/material";
import ArrowDownIcon from "@icons/myicons/arrow-down.svg?react";

const DropdownPaper = styled(Paper)(({ theme }) => ({
  maxHeight: 500,
  overflow: "hidden",
  marginTop: theme.spacing(1),
}));

const arrowIconStyle = (open: boolean) => ({
  minWidth: "24px",
  transform: open ? "rotate(180deg)" : "rotate(0deg)",
  transition: "transform 0.2s",
});

interface Props {
  anchorRef: React.RefObject<HTMLDivElement | null>;
  open: boolean;
  selectedLabel: string | undefined;
  searchQuery: string;
  label: string;
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onInputClick: () => void;
  onClose: () => void;
  children: React.ReactNode;
}

export const DesktopDropdown = ({
  anchorRef,
  open,
  selectedLabel,
  searchQuery,
  label,
  onInputChange,
  onInputClick,
  onClose,
  children,
}: Props) => {
  return (
    <ClickAwayListener onClickAway={onClose}>
      <Box>
        <TextField
          autoComplete="off"
          data-testid="dropdown-with-sections-input"
          ref={anchorRef}
          fullWidth
          value={open ? searchQuery : selectedLabel}
          onChange={onInputChange}
          onClick={onInputClick}
          placeholder={selectedLabel || label}
          slotProps={{
            input: {
              endAdornment: <ArrowDownIcon style={arrowIconStyle(open)} />,
            },
          }}
        />

        <Popper
          open={open}
          anchorEl={anchorRef?.current}
          placement="bottom-start"
          style={{
            width: anchorRef?.current?.offsetWidth,
            minWidth: "300px",
          }}
        >
          <DropdownPaper>{children}</DropdownPaper>
        </Popper>
      </Box>
    </ClickAwayListener>
  );
};
